module.exports = __webpack_public_path__ + "img/discount_bg2.b4179fa3.png";